<template>
    <div v-show="isVisible">
        <slot :input-name="name" />
    </div>
</template>
<script>
export default {
    props: {
        options: {
            required: true,
            type: Object
        },
        name: {
            required: true,
            type: String
        }
    },
    methods: {},
    computed: {
        isHidden() {
            /** @type {import('@spa/types/components').CompleteContactFormOptions} */
            const options = this.options;
            return !!options.hide?.[this.name];
        },
        isVisible() {
            return !this.isHidden;
        }
    },
}
</script>